"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapRaster = void 0;
const react_1 = __importDefault(require("react"));
const FabricMapImageData_1 = __importDefault(require("./FabricMapImageData"));
const gds_ux_components_1 = require("@granular/gds-ux-components");
require("./FabricMapRaster.scss");
exports.FabricMapRaster = react_1.default.memo((props) => {
    const { raster, legendOptions, before, onRender, rasterPaintOptions } = props;
    if (raster.imageData) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FabricMapImageData_1.default, { bounds: raster.bounds, imageData: raster.imageData, before: before, onRender: onRender, rasterPaintOptions: rasterPaintOptions }),
            legendOptions ? (react_1.default.createElement(gds_ux_components_1.GKPosition, { position: gds_ux_components_1.Position.BC, className: "fabric-map-raster-legend" },
                react_1.default.createElement(gds_ux_components_1.GKColorLegend, { options: Object.assign(Object.assign({}, legendOptions), { palette: raster.colorRange }) }))) : (react_1.default.createElement(react_1.default.Fragment, null))));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
});
exports.FabricMapRaster.displayName = "FabricMapRaster";
exports.default = exports.FabricMapRaster;
